import "./ReferralCabinetConditionsFooter.css";

export default function ReferralCabinetConditionsFooter({ isMobile, isPlusEnabled }: { isMobile: boolean, isPlusEnabled: boolean }) {
    const plusText = isPlusEnabled ? "Про кешбэк баллами" : "Про плюс"
    const plusLink = isPlusEnabled ? "https://yandex.ru/legal/plus_loyalty/" : "https://yandex.ru/legal/yandex_plus_conditions/"

    if (isMobile) {
        return <div className="Referral_cabinet_conditions_footer_mobile">
            <a className="Referral_cabinet_conditions_footer_text_mobile" href="https://yandex.ru/legal/drive_referral/" target="_blank">
                Про реферальный код
            </a>
            <a className="Referral_cabinet_conditions_footer_text_mobile" href={plusLink} target="_blank">
                {plusText}
            </a>
        </div>
    } else {
        return <div className="Referral_cabinet_conditions_footer">
            <a className="Referral_cabinet_conditions_footer_text" href="https://yandex.ru/legal/drive_referral/" target="_blank">
                Про реферальный код
            </a>
            <a className="Referral_cabinet_conditions_footer_text" href={plusLink} target="_blank">
                {plusText}
            </a>
        </div>
    }
}